export const SubscriptionBillingMode = Object.freeze({
  INVOICE: 1,
  TRIAL: 2,
  STRIPE: 3,
  NOT_STARTED: 4
});
